import api from '@/api'
import errors from '@/api/errors'
import store from '@/store'

const baseUrlRef = process.env.REVIEW_API_BASE_URL_REF
const baseUrlReg = process.env.REVIEW_API_BASE_URL_REG

const createPostParams = (args) => {
  const p = {}
  // required
  p.accessToken = store.getters['commons/cookies'].mchat
  p.sessionID = store.getters['commons/cookies'].encsid
  p.target_nickname = args.targetUser
  // non-required
  p.application = 2
  return p
}

const createDeleteParams = (args) => {
  const p = {}
  // required
  p.accessToken = store.getters['commons/cookies'].mchat
  p.sessionID = store.getters['commons/cookies'].encsid
  p.follow_id = args.followId
  // non-required
  p.application = 2
  return p
}

const createGetParams = (args) => {
  const p = {
    accessToken: store.getters['commons/cookies'].mchat,
    sessionID: store.getters['commons/cookies'].encsid,
    get_follow_status: args.get_follow_status || '0',
    sort: args.sort || '1',
    start: args.start || 0,
    count: args.count || 0
  }
  if (args.from) {
    p.from = args.from
  }
  if (args.to) {
    p.to = args.to
  }
  return p
}

const onReceived = (respBody) => {
  if (respBody.resultCode !== 0) {
    console.error(`API error code ${respBody.resultCode}`)
    if (respBody.resultCode === 611) { // アクセストークンエラー
      throw new errors.AuthenticationError()
    }
    throw new Error('問題が発生したためその後の処理を継続することができませんでした。時間を置いて再度利用をお願いします。')
  }
  return Promise.resolve(respBody.data)
}

export default {
  // フォロー登録
  registerFollow: (args) => {
    const params = createPostParams(args)
    return api.post(`${baseUrlReg}/registFollow`, params).then(onReceived)
  },
  // フォロー削除
  deleteFollow: (args) => {
    const params = createDeleteParams(args)
    return api.post(`${baseUrlReg}/deleteFollow`, params).then(onReceived)
  },
  // フォロー一覧取得
  getFollow: (args) => {
    const params = createGetParams(args)
    return api.post(`${baseUrlRef}/getFollow`, params).then(onReceived)
  }
}



// WEBPACK FOOTER //
// ./src/api/follows.js